module.exports = __webpack_public_path__ + "img/REALIZE.754319fe.jpg";